module.exports = __webpack_public_path__ + "img/i_map.cd9dcde1.svg";